import { render } from "./RoomSoldReportIndex.vue?vue&type=template&id=249daa43"
import script from "./RoomSoldReportIndex.vue?vue&type=script&lang=js"
export * from "./RoomSoldReportIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__